import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import {LicenseManager} from "@ag-grid-enterprise/core";
import { ModuleRegistry } from '@ag-grid-community/core';
import { RowGroupingModule } from '@ag-grid-enterprise/row-grouping';
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { MenuModule } from '@ag-grid-enterprise/menu';
import { MasterDetailModule } from '@ag-grid-enterprise/master-detail';
import { ExcelExportModule } from '@ag-grid-enterprise/excel-export';
import 'zone.js';

if (environment.production) {
  enableProdMode();
}
LicenseManager.setLicenseKey(environment.AG_GRID_LICENSE);
ModuleRegistry.registerModules([ClientSideRowModelModule, RowGroupingModule, MenuModule, MasterDetailModule, ExcelExportModule
]);
// Handle silent refresh
const urlParams = new URLSearchParams(window.location.search);

if (urlParams.get('silent-refresh') === 'true') {

  const fragment = window.location.hash || '';

  if (window.parent) {
    try {
      window.parent.postMessage(fragment, window.location.origin);
    } catch (error) {
      console.error('Error posting message to parent window:', error);
    }
  } else {
    console.error('Silent refresh detected but no parent window found.');
  }

  // Close iframe after sending the token
  setTimeout(() => window.close(), 500);
}


platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
